<template>
  <v-toolbar-items v-if="$store.state.account.user != null">

    <v-btn :to="'/'" text>Home</v-btn>

    <template v-for="(nav, navIndex) in navigation">

      <v-btn v-if="!nav.menu" :key="navIndex" :to="{name: nav.name, params: nav.params}" text>
        {{nav.label}}
      </v-btn>

      <template v-else-if="nav.items && nav.items.length > 0">

        <v-menu v-if="nav.menu === 'Account'" offset-y :key="navIndex">
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
              <v-icon>person</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, menuIndex) in nav.items" :key="menuIndex"
                         :to="{ name: item.name, params: item.params }"
                         :disabled="item.name === currentRouteName">
              <v-list-item-title v-text="item.label"/>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-menu v-else offset-y :key="navIndex">
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">{{nav.menu}}</v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, menuIndex) in nav.items" :key="menuIndex"
                         :to="{ name: item.name, params: item.params }"
                         :disabled="item.name === currentRouteName">
              <v-list-item-title v-text="item.label"/>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </template>
  </v-toolbar-items>
</template>

<style scoped>
.v-list-item--active {
  opacity: .5;
}
</style>

<script>
export default {
  name: 'Navigation',
  computed: {
    navigation() {
      const nav = [];

      this.$router.options.routes.forEach((route) => {
        const routeMeta = route.meta;
        if (!routeMeta || !routeMeta.nav) {
          return;
        }

        const routeParams = routeMeta.params ? routeMeta.params() : {};
        const numParamsRequired = Object.keys(routeParams).length;
        const numParamsDefined = Object.values(routeParams).filter((val) => !!val).length;
        if (numParamsRequired !== numParamsDefined) {
          return;
        }

        if (routeMeta.auth && !routeMeta.auth(this.$auth.checkAuth)) {
          return;
        }

        if (!routeMeta.nav.menu) {
          nav.push({
            name: route.name,
            label: route.meta.nav.label,
            params: route.meta.params ? route.meta.params() : '',
          });
        } else {
          const navMenuIndex = nav.findIndex(({ menu }) => menu === routeMeta.nav.menu);
          if (navMenuIndex < 0) {
            nav.push({
              menu: routeMeta.nav.menu,
              items: [{
                name: route.name,
                label: route.meta.nav.label,
                params: route.meta.params ? route.meta.params() : '',
              }],
            });
          } else {
            nav[navMenuIndex].items.push({
              name: route.name,
              label: route.meta.nav.label,
              params: route.meta.params ? route.meta.params() : '',
            });
          }
        }
      });

      return nav;
    },
    currentRouteName() {
      return this.$route.name;
    },
  },
};
</script>
